import {
  TextField as MuiTextField,
  type TextFieldProps as MuiTextFieldProps,
} from '@mui/material';
import { forwardRef } from 'react';

export type TextFieldProps = MuiTextFieldProps;

export const TextField = forwardRef<HTMLDivElement, TextFieldProps>(function TextField(
  props,
  ref,
) {
  return <MuiTextField ref={ref} {...props} />;
});
